import { getEnv } from '../helpers/functions'
import { combineReducers } from '@reduxjs/toolkit'
import { configureStore } from '@reduxjs/toolkit'
import * as reducers from '../redux/reducers'
import { apiService } from './api-service'
import { stockReducer } from './slices/stock.slice'
import { createLogger } from 'redux-logger/src'
import { metaReducer } from './slices/meta.slice'

const logger = createLogger({
    collapsed: true,
})

const store = configureStore({
    reducer: combineReducers({
        ...reducers,
        stockv2: stockReducer,
        meta: metaReducer,
        [apiService.reducerPath]: apiService.reducer,
    }),

    middleware: getDefaultMiddleware => {
        const conf = [apiService.middleware]
        if (getEnv('REACT_APP_ENV') !== 'production') {
            conf.push(logger)
        }
        return getDefaultMiddleware().concat(conf)
    },
})

export type RootState = ReturnType<typeof store.getState>

export default store
